<template>
    <div>
 
      <div  style="position: relative;">
         <!-- Label for input -->
         <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editorRef"
            :defaultConfig="toolbarConfig"          
            :mode="mode"
          />
          <Editor 
            style="height: 500px; overflow-y: hidden;"
            v-model="inputText"
            :defaultConfig="editorConfig"
            :mode="mode"
            @on-change="handleEditorChange"
            @on-created="handleEditorCreated"
          />
    
        <!-- Buttons for Spell Check and Use AI -->
        <n-button @click="useAI" type="info" style="position: absolute; bottom: 10px; right: 8px; font-size: 10px;height: 20px;">Use AI</n-button>        
      </div>
     
      
  
      <!-- Naive UI Modal for AI Suggestions -->
      <n-modal v-model:show="showModal">
        <n-card
          style="max-width: 800px; width: 80vw;"
          :title="modalTitle"
          :bordered="false"
          size="medium"
          role="dialog"
          aria-modal="true"
          closable @close="cancelAISuggestion"
        >
        
          <div id="content-wrapper">
            <div class="bold">From:</div>
            <div class="info" v-html="originalContent"></div>
            <div class="bold">To:</div>
            <div class="info" v-html="aiSuggestedContent"></div>
          </div>
  
          <template #footer >
            <n-button @click="cancelAISuggestion" style="margin-left: 10px;float:right;">Cancel</n-button>
            <n-button @click="applyAISuggestion" type="primary" style="float:right;">{{btnAcceptText}}</n-button>
           
          </template>
        </n-card>
      </n-modal>
    </div>
  </template>
  
  <script>
  import { ref, watch, onBeforeUnmount, shallowRef  } from "vue";
  import { NButton, NModal, NCard, c, inputDark } from "naive-ui";

 

  import useAi from "../composables/useAi";
  import '@wangeditor/editor/dist/css/style.css' 
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

  import { i18nChangeLanguage, toolbarConfig  } from '@wangeditor/editor'


 
  export default {
    components: {
      NButton,
      NModal,
      NCard,
      Editor, Toolbar,
    },
    props: {
      // Props for customization
      placeholder: {
        type: String,
        default: "Enter your own Contract terms here",
      },
      initialText: {
        type: String,
        default: "",
      },
      editable:{
        type: Boolean,
        default: true
      },
        originalIndex: {
          type: Number,
          default: 0
        }
    },

    emits: ["update:text", "updateTerm", "showLoader", "hideLoader", "update:initialText"], // Defining the emit event
    

    setup(props, { emit }) {

      const ai = useAi();


      i18nChangeLanguage('en')

      const toolbarConfig = {
        excludeKeys: [
          'fontFamily',
          'fullScreen',
          'emotion'
        ]
      }

      const mode = ref('default')

      const editorRef = shallowRef()
 
      const editorConfig = { placeholder: props.placeholder}


      const modalTitle = ref("AI Suggest you to use the following Terms description");
      const inputText = ref(props.initialText);
      const showModal = ref(false);
      const originalContent = ref("This is the original content.");
      const aiSuggestedContent = ref("This is the AI suggested content.");

      const btnAcceptText = ref("Use AI Suggestion");

      const _originalIndex = ref(props.originalIndex);

      watch(
        () => props.initialText,
        (newValue) => {
          //console.log("initialText changed:", newValue);
          //inputText.value = newValue;
          if (editorRef.value && editorRef.value.getHtml() !== newValue) {
            editorRef.value.setHtml(newValue);
          }
 
        },
        { immediate: true } // Ensures pre-filling on mount
      );

      const insertText = (html) => {
        const editor = editorRef.value // get editor instance, after it's rendered
        if (editor == null) return

        editor.insertText(html) ;// trigger editor API
    }

      const handleEditorCreated = (editor) => {
        editorRef.value = editor;
 
        editor.setHtml(inputText.value);
      };
      
    const handleEditorChange = (editor) => {

      //console.log("Editor content changed:", editor.getHtml());

      const newValue = editor.getHtml();
      emit('update:initialText', newValue);
      emit('updateTerm', _originalIndex.value, newValue);
      
    };

      const initData = (text) => {
        //console.log("initData called",text);
        if(!text) return;
        inputText.value = text;
        emit("update:text", inputText.value);
 
      }

      onBeforeUnmount(() => {
        const editor = editorRef.value
        if (editor == null) return
        editor.destroy()
      })

 
     
      const handleTextChange = (e) => {
       
        emit("update:text", inputText.value); // Emit updated text to parent

        emit("updateTerm", _originalIndex.value, inputText.value); // Emit updated text to parent
        
        console.log("handleTextChange called", _originalIndex.value, inputText.value);
      }

      const handleBlur = (e) => {
        console.log("Blur event triggered");
        console.log(e.target.innerHTML);
        inputText.value = e.target.innerHTML;
        // Optional: emit change to parent or save changes
      };
  
      // Spell Check Functionality
      const spellCheck = async () => {
        const text = inputText.value;
        originalContent.value = text.replace(/\n/g, "<br>");

        if(originalContent.value == "") return;

        emit("showLoader");
        try {
            const suggestion = await ai.spellCheck(text);

            emit("hideLoader");

            if(!suggestion) return;

            modalTitle.value = "Spell check suggests the following changes";
            btnAcceptText.value = "Accept Suggestions";

            const aiText = cleanAiText(suggestion);

            aiSuggestedContent.value = aiText.replace(/\n/g, "<br>");
            showModal.value = true; // Show the modal with AI suggestions
        } catch (error) {
            emit("hideLoader");
            console.error("Error calling AI service:", error);
        }
      };


      const cleanAiText = (text) => {
        console.log("cleanAiText called",text);
        if(!text) return '';
        text = text.trim();
        let firstParagraph = text.split("\n\n");

        if(firstParagraph && 
          (
            firstParagraph[0].startsWith("Here is the") || firstParagraph[0].startsWith("Here's the") 
            || firstParagraph[0].indexOf("improved text") > -1  || firstParagraph[0].indexOf("improved version")  > -1
          )
        ){

          //console.log("found improved text", text);

          let index = text.indexOf("\n");
          let cleanText = text.substring(index + 1, text.length).trim();

          //console.log("substring", cleanText);

          let paragaphs = cleanText.split("\n");
          if(paragaphs.length > 1){
              cleanText = '';

              paragaphs.forEach((paragraph, index) => {
                //console.log("paragraph", paragraph);
                if(paragraph != "```" && paragraph != "```html"){
                  cleanText += paragraph;
                }
                      
                cleanText += '\n';
              });
             
          }

          cleanText = cleanText.trim();
          if(cleanText.startsWith("\"") && cleanText.endsWith("\"")) 
            cleanText = cleanText.substring(1, cleanText.length - 1);

          if(cleanText.startsWith("```html") && cleanText.endsWith("```")) {
            cleanText = cleanText.substring(7, cleanText.length - 3);
          }
            

          return cleanText;
        }else{


          let index = text.indexOf("\n");
          let cleanText = text.substring(index + 1, text.length).trim();

          //console.log("substring", cleanText);

          let paragaphs = cleanText.split("\n");
          if(paragaphs.length > 1){
              cleanText = '';

              paragaphs.forEach((paragraph, index) => {
                //console.log("paragraph", paragraph);
                if(paragraph != "```" && paragraph != "```html"){
                  cleanText += paragraph;
                }
                      
                cleanText += '\n';
              });
             
          }

          cleanText = cleanText.trim();
          if(cleanText.startsWith("\"") && cleanText.endsWith("\"")) 
            cleanText = cleanText.substring(1, cleanText.length - 1);

          if(cleanText.startsWith("```html") && cleanText.endsWith("```")) {
            cleanText = cleanText.substring(7, cleanText.length - 3);
          }
          return cleanText;
        }
      };
  
      // Use AI Functionality
      const useAI = async () => {
        const text = inputText.value;
        originalContent.value = text;

        if(originalContent.value == "") return;

        emit("showLoader");
        try {
            const suggestion = await ai.improve(text, true);

            emit("hideLoader");

            if(!suggestion) return;

            modalTitle.value = "AI Suggest the following grammatical changes to your Term Description";
            btnAcceptText.value = "Use AI Suggestion";

            const aiText = cleanAiText(suggestion);

            aiSuggestedContent.value = aiText;
            showModal.value = true; // Show the modal with AI suggestions
        } catch (error) {
            emit("hideLoader");
            console.error("Error calling AI service:", error);
        }
      };
  
      // Apply AI Suggestion
      const applyAISuggestion = () => {
        const textWithoutHtml = aiSuggestedContent.value;

       // console.log("applyAISuggestion", textWithoutHtml);

        // Update inputText with the cleaned content
        inputText.value = textWithoutHtml;

        // Optional: emit change to parent or save changes
        insertText(textWithoutHtml);

        
        showModal.value = false;
        //emit("update:text", inputText.value); // Emit updated text to parent

        //emit("updateTerm", _originalIndex.value, inputText.value); // Emit updated text to parent
      };
  
      // Cancel AI Suggestion
      const cancelAISuggestion = () => {
        showModal.value = false;
      };
  
      return {
        inputText,
        showModal,
        _originalIndex,
        originalContent,
        aiSuggestedContent,
        spellCheck,
        useAI,
        applyAISuggestion,
        cancelAISuggestion,
        modalTitle,
        btnAcceptText,
        handleBlur,
        initData,
        handleTextChange,

        editorRef,
 
        mode: 'default', // 或 'simple'
        toolbarConfig,
        editorConfig,
        handleEditorCreated,
        handleEditorChange,
        insertText,

      };
    },
  };
  </script>
  
  <style scoped>
  /* Add your custom styles here */

  #content-wrapper {
    max-height: 80vh; /* Set a fixed height */
    overflow-y: auto; /* Enable vertical scrolling */
    padding: 10px;
  }

  /* Optional: Improve scrolling experience */
  #content-wrapper::-webkit-scrollbar {
    width: 6px;
  }

  #content-wrapper::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 3px;
  }

  .info{ font-size: 12px; margin: 12px 0px;}

  </style>